<div class="MarkNotBillableDialog" [formGroup]="inputForm">
  <p class="mb-3">
    Choose whether this account is billable in Stripe or billed outside the app.
    Off-app billed accounts do not need a Stripe subscription, and Update Credit Card is hidden
    for the user.
  </p>

  <div class="row mb-3">
    <div class="col col-12">
      <mat-radio-group formControlName="billing_mode" aria-label="Billing mode">
        <mat-radio-button [value]="modeBillable">Mark billable</mat-radio-button>
        <mat-radio-button [value]="modeNotBillable">Not billable</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <ng-container *ngIf="isNotBillableMode">
    <div class="row">
      <div class="col col-12 col-sm-4 d-flex align-items-center">
        <mat-label>Billing designation</mat-label>
      </div>
      <div class="col col-12 col-sm-8">
        <app-select
          label="Select designation"
          [items]="designationItems"
          formControlName="billing_designation"
        ></app-select>
      </div>
    </div>
    <div class="row mt-3" *ngIf="showInvoiceNote">
      <div class="col col-12 col-sm-4 d-flex align-items-center">
        <mat-label>Invoice note</mat-label>
      </div>
      <div class="col col-12 col-sm-8">
        <app-text-field formControlName="invoice_note" placeholder="Invoice note (required)"></app-text-field>
      </div>
    </div>
  </ng-container>

  <div *ngIf="!isNotBillableMode" class="alert alert-warning mt-2 mb-0">
    This clears billing designation and invoice note. The user will need a Stripe subscription
    (or can be marked not billable again). Update Credit Card will be shown when they log in.
  </div>
</div>
